"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseNumberDef = void 0;
function parseNumberDef(def, refs) {
    const res = {
        type: "number",
    };
    if (def.checks) {
        for (const check of def.checks) {
            switch (check.kind) {
                case "int":
                    res.type = "integer";
                    break;
                case "min":
                    if (refs.target === "jsonSchema7") {
                        if (check.inclusive) {
                            res.minimum = check.value;
                        }
                        else {
                            res.exclusiveMinimum = check.value;
                        }
                    }
                    else {
                        if (!check.inclusive) {
                            res.exclusiveMinimum = true;
                        }
                        res.minimum = check.value;
                    }
                    break;
                case "max":
                    if (refs.target === "jsonSchema7") {
                        if (check.inclusive) {
                            res.maximum = check.value;
                        }
                        else {
                            res.exclusiveMaximum = check.value;
                        }
                    }
                    else {
                        if (!check.inclusive) {
                            res.exclusiveMaximum = true;
                        }
                        res.maximum = check.value;
                    }
                    break;
                case "multipleOf":
                    res.multipleOf = check.value;
                    break;
            }
        }
    }
    return res;
}
exports.parseNumberDef = parseNumberDef;
